import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { Row, Col, Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import { Label } from 'reactstrap';

//Api
import ramoDeAtividade_api from '../../../api/ramoDeAtividade_api';

//Helpers
import { showMessage } from '../../../helpers/message';
import { PrintValidate, validarCampos, objCampo } from '../../../helpers/ValidadorDeCampos';

//Components
import MainCard from '../../../components/MainCard/MainCard';
import TextField from '../../../components/TextField/TextField';
import Loading from '../../../components/Loading/Loading';
import TabelaListagem from '../../../components/TabelaListagem/TabelaListagem';
import ModalCustomized from '../../../components/Modal/Modal';

//Constants
import { actionsTable } from '../../../constants/MaterialTable';

//estado inicial do ramo de atividade
function initialStateRamoAtividade() {
    return {
        descricao: "",
        icone: "",
        status: ""
    }
}

//estado inicial dos icones
function initialStateIcones() {
    return [
        { icone: "icone-padrao.png", name: "Padrão" },
        { icone: "icone-admimoveis.png", name: "Administração de Imóveis" },
        { icone: "icone-admpublica.png", name: "Administração Pública" },
        { icone: "icone-alimenticia.png", name: "Alimentícia" },
        { icone: "icone-ambulante.png", name: "Ambulante" },
        { icone: "icone-atacadista.png", name: "Atacadista" },
        { icone: "icone-autopecas.png", name: "Auto Peças" },
        { icone: "icone-financeira.png", name: "Banco ou Entidade" },
        { icone: "icone-bares.png", name: "Bares" },
        { icone: "icone-bebidas.png", name: "Bebidas" },
        { icone: "icone-borracha.png", name: "Borracha" },
        { icone: "icone-complexodesportivo.png", name: "Complexo Desportivo" },
        { icone: "icone-condominios.png", name: "Condomínios" },
        { icone: "icone-construcao.png", name: "Construção" },
        { icone: "icone-couros.png", name: "Couros" },
        { icone: "icone-editoral.png", name: "Editoral e Gráfica" },
        { icone: "icone-classe.png", name: "Entidade de Classe" },
        { icone: "icone-entidadefinanceira.png", name: "Entidade Financeira" },
        { icone: "icone-escritorios.png", name: "Escritórios" },
        { icone: "icone-minerio.png", name: "Extração e Tratamento de Mineirais" },
        { icone: "icone-fastfood.png", name: "FastFood" },
        { icone: "icone-feiras.png", name: "Feiras" },
        { icone: "icone-fumo.png", name: "Fumo" },
        { icone: "icone-grafica.png", name: "Gráfica" },
        { icone: "icone-hospital.png", name: "Hospital" },
        { icone: "icone-hotel.png", name: "Hotel" },
        { icone: "icone-industrias.png", name: "Industrias" },
        { icone: "icone-lavanderias.png", name: "Lavanderias" },
        { icone: "icone-madeira.png", name: "Madeira" },
        { icone: "icone-materialeletrico.png", name: "Material Elétrico" },
        { icone: "icone-metalurgia.png", name: "Metalurgia" },
        { icone: "icone-naometalicos.png", name: "Mineirais Não Metálicos" },
        { icone: "icone-imoveis.png", name: "Mobiliário" },
        { icone: "icone-outroscomercios.png", name: "Outros Comércios" },
        { icone: "icone-outrasindustrias.png", name: "Outras Indústrias" },
        { icone: "icone-papel.png", name: "Papel" },
        { icone: "icone-perfumaria.png", name: "Perfumaria" },
        { icone: "icone-alimentares.png", name: "Produtos Alimentares" },
        { icone: "icone-plasticos.png", name: "Produtos de Materiais Plásticas" },
        { icone: "icone-farmaceuticos.png", name: "Produtos Farmaceuticos" },
        { icone: "icone-quimica.png", name: "Química" },
        { icone: "icone-quiosque.png", name: "Quiosque" },
        { icone: "icone-restaurantes.png", name: "Restaurantes" },
        { icone: "icone-servicoescritorio.png", name: "Serviços Comerciais Escritórios" },
        { icone: "icone-alojamento.png", name: "Serviços de Alojamento" },
        { icone: "icone-diversoes.png", name: "Serviços de Diversões" },
        { icone: "icone-ong.png", name: "Servicos de Fundações" },
        { icone: "icone-reparos.png", name: "Serviço de Reparação e Manutenção" },
        { icone: "icone-energiaeletrica.png", name: "Serviço Público de Energia Elétrica" },
        { icone: "icone-shopping.png", name: "Shopping" },
        { icone: "icone-supermercado.png", name: "Supermercado" },
        { icone: "icone-textil.png", name: "Têxtil" },
        { icone: "icone-transporte.png", name: "Transporte" },
        { icone: "icone-transppublico.png", name: "Transporte Público" },
        { icone: "icone-utilidadepublica.png", name: "Utilidade Pública" },
        { icone: "icone-vesturario.png", name: "Vestuário" },
    ];
}

//Opções para o select de status do ramo de atividade
const optionsStatus = [
    { text: "Ativo", value: "Ativo" },
    { text: "Inativo", value: "Inativo" },
]

export default function RamoDeAtividade({ permissao }) {
    //Estado que guarda os dados do ramo de atividade para cadastrar/editar
    const [ramoAtividade, setRamoAtividade] = useState(initialStateRamoAtividade);

    //Estado que guarda a lista de ramos de atividades
    const [ramosDeAtividade, setRamosDeAtividade] = useState([]);

    //estado que controla a exibição do select de icone do ramo de atividade
    const [dropdownOpen, setDropdownOpen] = useState(false);

    //Estado de controle de exibição do modal de edição/cadastro
    const [openModal, setOpenModal] = useState(false);

    //Estado de controle dos icones do ramo de atividade
    const [icones, setIcones] = useState(initialStateIcones);

    //Estado de controle dos erros nos campos obrigatorios
    const [errors, setErrors] = useState({});

    //Estado de controle do loading na tela
    const [loading, setLoading] = useState(false);

    //Campos obrigatorios do formulario de ramo de atividade
    const campos = [
        objCampo({ name: "descricao", required: true }),
        objCampo({ name: "icone", required: true }),
        objCampo({ name: "status", required: true }),
    ]

    //Função de troca de visibilidade do dropdown dos icones
    const toggleDropDown = () => {
        setDropdownOpen(!dropdownOpen);
    };

    //Carrega a lista de ramos de atividade assim que a tela é carregada
    useEffect(() => {
        loadRamosAtividade();
    }, []);

    //Função que carrega os ramos de atividade 
    const loadRamosAtividade = () => {
        setLoading(true);
        ramoDeAtividade_api.GetList().then(response => {
            response.data.map(value => {
                value.iconeImage = <img src={`data:image;base64,${value.icone}`} width="32px" height={"auto"} />;
                return value;
            })
            setRamosDeAtividade(response.data);
        }).catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(f => setLoading(false));
    }

    //Função de controle do modal de edição/cadastro
    const toggleModal = () => {
        if (openModal) {
            setRamoAtividade(initialStateRamoAtividade);
            setErrors({});
        }
        setOpenModal(!openModal);
    }

    //OnChange dos campos do ramo de atividade
    const onChangeRamoAtividade = (e) => {
        const { name, value } = e.target;
        const _ramoAtividade = {
            ...ramoAtividade,
            [name]: value
        }
        const campo = campos.filter(c => c.name === name);
        const erros = validarCampos(_ramoAtividade, campo);
        if (erros[1].length == 0) {
            const _errors = { ...errors };
            delete _errors[name];
            setErrors(_errors);
        } else {
            setErrors({ ...errors, ...erros[0] })
        }
        setRamoAtividade(_ramoAtividade)
    }

    //Função que faz o cadastro / edição do ramo de atividade
    const addRamoAtividade = () => {

        const _errors = validarCampos(ramoAtividade, campos);
        if (_errors[1].length > 0) {
            setErrors(_errors[0]);
            return;
        }
        setLoading(true);
        const _ramoAtividade = { ...ramoAtividade }
        if (ramoAtividade.icone) {
            _ramoAtividade.iconeNome = ramoAtividade.icone.icone;
            _ramoAtividade.icone = require("../../../assets/img/icones/" + ramoAtividade.icone.icone).split("base64,")[1];
        }
        if (ramoAtividade.id) {
            delete _ramoAtividade.iconeImage;
            ramoDeAtividade_api.Put(_ramoAtividade).then(response => {
                loadRamosAtividade();
                toggleModal();
                showMessage("Sucesso", "Sucesso ao editar o ramo de atividade", "success", null);
            }).catch(e => showMessage("Aviso", e.message, "error", null))
                .finally(f => setLoading(false));
        } else {
            ramoDeAtividade_api.Post(_ramoAtividade).then(response => {
                loadRamosAtividade();
                toggleModal();
                showMessage("Sucesso", "Sucesso ao cadastrar o ramo de atividade", "success");
            }).catch(e => showMessage("Aviso", e.message, "error", null))
                .finally(f => setLoading(false));
        }
    }

    //Função que executa o procedimento de edição ao clicar no botão da tabela
    const editarRamoAtividade = (item, itemKey) => {
        item.icone = icones.filter(value => value.icone === item.iconeNome)[0];
        setRamoAtividade(item);
        toggleModal();
    }

    //Cabeçalhos da tabela de listagem
    const headers = [
        { value: "Descrição", objectValue: "descricao", align: "left" },
        { value: "Ícone", objectValue: "iconeImage" },
        { value: "Status", objectValue: "status" }
    ];

    //Ações da tabela de listagem
    const actions = [];
    if (permissao === "Editar")
        actions.push(actionsTable.editar(editarRamoAtividade));
    return (
        <>
            {loading && <Loading />}
            <MainCard noCard btnCadastro={permissao === "Editar" ? "Adicionar" : null} onClickBtnCadastro={toggleModal}>
                <ModalCustomized isOpen={openModal} toggle={toggleModal} title={ramoAtividade.id ? <><FontAwesomeIcon icon={faEdit} /> Editar ramo de atividade</> : "+ Adicionar novo ramo de atividade"} btnAction={ramoAtividade.id ? <><FontAwesomeIcon icon={faEdit} /> Editar</> : "+ Adicionar"} btnActionColor={ramoAtividade.id ? "warning text-light" : "success"} onClickBtnAction={addRamoAtividade} btnClose>
                    <Row className='mb-4'>
                        <Col md="12" lg="12"><span className="text-danger fw-bold">*</span> Campos obrigatórios</Col>
                    </Row>
                    <Row>

                        <Col md="12" lg="6">
                            <TextField invalid={errors.descricao ? true : false} maxLength={"50"} label={"* Descrição"} name={"descricao"} value={ramoAtividade.descricao} onChange={onChangeRamoAtividade} />
                            <PrintValidate field={"descricao"} errors={errors} />
                        </Col>
                        <Col md="12" lg="6">
                            <Label className=' label'>
                                * Tipo
                            </Label>
                            <Dropdown className={`dropdown-field ${errors.icone ? "disable" : ""}`} isOpen={dropdownOpen} toggle={toggleDropDown}>
                                <DropdownToggle caret>
                                    <p style={ramoAtividade.icone && ramoAtividade.icone != "" ? { backgroundImage: `url("${require("../../../assets/img/icones/" + ramoAtividade.icone.icone)}")` } : {}} className={`dropdown-main-text ${ramoAtividade.icone != "" ? "selected" : ""}`}>
                                        {ramoAtividade.icone ? ramoAtividade.icone.name : "Icone"}
                                    </p>
                                </DropdownToggle>
                                <DropdownMenu>
                                    {icones.map(value => {
                                        return (
                                            <DropdownItem style={{ backgroundRepeat: "no-repeat", backgroundImage: `url("${require("../../../assets/img/icones/" + value.icone)}")`, color: "#f00" }} onClick={() => {
                                                const e = {};
                                                e.target = {};
                                                e.target.name = "icone";
                                                e.target.value = value;
                                                onChangeRamoAtividade(e);
                                            }}>
                                                <span> {value.name}</span>
                                            </DropdownItem>
                                        );
                                    })}

                                </DropdownMenu>
                                <PrintValidate field={"icone"} errors={errors} />
                            </Dropdown>
                        </Col>
                        <Col md={"12"} lg={"6"}>
                            <TextField maxLength={"20"} label={"* Status"} type="select" options={optionsStatus} name="status" value={ramoAtividade.status} onChange={onChangeRamoAtividade} invalid={errors.status ? true : false} />
                            <PrintValidate field={"status"} errors={errors} />
                        </Col>
                    </Row>

                </ModalCustomized>
                <div className="mt-4">
                    <TabelaListagem actions={actions} title={"Lista de ramos de atividade"} options={{ print: false, search: true, pagination: true }} headers={headers} items={ramosDeAtividade} />
                </div>
            </MainCard >
        </>
    )
}